import { Grid } from "@material-ui/core";
import EmptyPlaceholder from "components/EmptyPlaceholder/EmptyPlaceholder";
import ExportButton from "components/ExportButton/ExportButton";
import { useGetClientsQuery } from "features/clients/clientSlice";
import { useGetLotsQuery } from "features/lots/lotSlice";
import { selectTenantName } from "features/user/userSlice";
import { useGetVehiclesQuery } from "features/vehicles/vehicleSlice";
import { IconDownload } from 'icons';
import { groupBy } from "lodash";
import { useSelector } from "react-redux";
import { Bar, BarChart, LabelList, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { theme } from "styles/theme";
import { AssetListDialog } from "../AllAssetCountOnLot/AssetListDialog";
import { dispatchDashboardStyle } from "../style";

const DomiciledCount = ({ outOfPmfResponsibilityId }) => {
    const classes = dispatchDashboardStyle()

    const tenantName = useSelector(selectTenantName);

    let { data: lots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    let { data: vehiclesData, error: vehicleError, isFetching: isFetchingVehicles, refetch: refetchVehicles } = useGetVehiclesQuery({ includeHistory: false });
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null);
    const clientAccounts = clients?.flatMap(c => c.clientAccounts);

    const { filters } = useSelector(state => state.dashboardState);

    const tenantLots = lots?.filter(l => l.ownedByTenant)?.map(l => l.id);

    let filteredData = vehiclesData?.filter(v =>
        (filters.isDefaultAccount ? (!filters.clientId || filters.clientId == v.clientId)
            : (!filters.clientAccountId || filters.clientAccountId == v.clientAccountId)) &&
        v.vehicleStatusId != outOfPmfResponsibilityId &&
        v.domicileLot && tenantLots?.includes(v.domicileLot)
    );

    const dataGrouped = groupBy(filteredData, 'domicileLot');

    const finalData = Object.keys(dataGrouped).map(key => ({ lotId: key, count: dataGrouped[key]?.length }));

    const mapExportData = row => {
        return ({
            'VIN': row.descriptor,
            'Asset Id': row.assetId,
            'Client': clientAccounts?.find(c => c.id == row.clientAccountId)?.name,
            'Lot': lots?.find(c => c.id == row.lotId)?.name,
            'Domicile Lot': lots?.find(c => c.id == row.domicileLot)?.name,
        })
    };

    return (
        <div>

            <Grid container justifyContent="space-between" >
                <h4 className={classes.graphTitle}>Assets Domiciled on {tenantName} lots</h4>
                <div>
                    <AssetListDialog data={filteredData} />
                    <ExportButton btnStyle='text' label="" icon={<IconDownload />} fileLabel="Export" data={filteredData} mapExportData={mapExportData} />
                </div>
            </Grid>
            {!!finalData?.length ?
                <div style={{ width: "100%", height: finalData?.length * 40 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            layout="vertical"
                            data={finalData}
                            margin={{ top: 30, right: 30, left: 100, bottom: 5 }}
                        >
                            <XAxis
                                type="number"
                                dataKey="count"
                                axisLine={false}
                                tickLine={false}
                            />

                            <YAxis
                                type="category"
                                axisLine={false}
                                dataKey="lotId"
                                tickLine={false}
                                tick={{ color: theme.palette.primary.main, fontSize: '1em', fontWeight: '500' }}
                                tickFormatter={lotId => {
                                    return lots?.find(l => l.id == lotId)?.name;
                                }}
                            />

                            <Bar
                                dataKey="count"
                                fill={'#efc761'}
                            >
                                <LabelList dataKey="count" position="outside" style={{ fill: theme.palette.primary.contrastText }} />
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                :
                <EmptyPlaceholder text='No Washes' />}

        </div>)
}

export default DomiciledCount;